import React, { ReactNode } from 'react';
import { LinearProgress, Typography } from '@material-ui/core';

export interface LoadingErrorContainerProps {
  error?: string | null;
  loading: boolean;
  children: ReactNode;
  className?: string;
}

export default function LoadingErrorContainer(
  props: LoadingErrorContainerProps,
) {
  const {
    error, loading, children, className,
  } = props;

  if (loading) {
    return <LinearProgress className={className} />;
  } else if (error != null) {
    return (
      <Typography color="error" className={className}>{error}</Typography>
    );
  } else {
    return <div className={className}>{children}</div>;
  }
}
